@if (facility$ | async; as facility) {
  @if (pageInfo$ | async; as pageInfo) {
    <gbc-page-header [pageInfo]="pageInfo">
      <ng-container gbc-page-header-actions>
        <button
          gbc-menu-item
          (click)="editFacility()"
          angulartics2On="click"
          angularticsAction="editFacilityShown"
          angularticsCategory="buildingConnectFacility"
          >
          <img style="margin-right: 10px" src="./assets/svgs/edit.svg" />
          {{ 'facility-page-content.edit-facility' | translate }}
        </button>
      </ng-container>
    </gbc-page-header>
  }
  <gbc-page-container>
    @if (installationViewModels$ | async; as installations) {
      <gbc-tile [title]="'facility-page-content.installations' | translate">
        @if (installations.length) {
          <gbc-table clickableRows="true">
            <th gbc-table-header>{{ 'facility-page-content.installation' | translate }}</th>
            <th gbc-table-header>{{ 'facility-page-content.state' | translate }}</th>
            @for (installation of installations; track installation) {
              <tr gbc-table-row (rowClicked)="installation.navigateTo()">
                <td gbc-table-cell>
                  <div class="installation-cell-content">
                    @if (installation.iconUrl) {
                      <img class="installation-icon" [src]="installation.iconUrl" />
                    }
                    <div>{{ installation.name || installation.id }}</div>
                  </div>
                </td>
                <td gbc-table-cell>
                  @if (installation.stateTextKey) {
                    {{ installation.stateTextKey | translate }}
                  }
                </td>
              </tr>
            }
          </gbc-table>
        }
        @if (!installations.length) {
          <div style="text-align: center; padding: 2em">
            {{ 'facility-page-content.no-installations-on-facility' | translate }}
          </div>
        }
      </gbc-tile>
    }
  </gbc-page-container>
}
